module.exports = __webpack_public_path__ + "img/EffectTwo.d677096b.png";